import React from 'react';
import Button from 'react-bootstrap/esm/Button';
import Modal from 'react-bootstrap/esm/Modal';
import Spinner from 'react-bootstrap/esm/Spinner';
import './ConfirmModal.scss';

export interface IConfirmModalProps {
  title: string|JSX.Element;
  body: string|JSX.Element;
  cancelLabel?: string;
  confirmLabel?: string;
  confirmButtonStyle?: 'danger'|'default';
  canceling?: boolean;
  confirming?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmModal = ({ title, body, cancelLabel, confirmLabel, confirmButtonStyle, canceling, confirming, onCancel, onConfirm }: IConfirmModalProps): JSX.Element => (
  <Modal className="confirm-modal" show={true} onHide={onCancel}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{body}</Modal.Body>
    <Modal.Footer>
      <Button className="confirm-modal__btn--light" disabled={canceling} onClick={onCancel}>
        { canceling && <Spinner animation="border" variant="light" size="sm" /> }
        { cancelLabel ?? 'Annuleren' }
      </Button>
      <Button className={confirmButtonStyle === 'danger' ? 'confirm-modal__btn--danger' : 'confirm-modal__btn--default'} onClick={onConfirm} disabled={confirming}>
        { confirming && <Spinner animation="border" variant="danger" size="sm" /> }
        { confirmLabel ?? 'Bevestig' }
      </Button>
    </Modal.Footer>
  </Modal>
);
